module.exports = __webpack_public_path__ + "static/img/img_title_01.8c3ee94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_title_01.png
// module id = 189
// module chunks = 1